import * as React from 'react'
import { bind } from 'classnames/bind'
import * as styles from '@procore/core-css/src/components/_tokens.scss'

import { Props, DivAttributes, SpanAttributes } from '../utils/types'
import IconBase, { IconProps } from './Icon'
import addSubcomponents from '../utils/addSubcomponents'

export namespace TokenVariantNS {
  export const disabled = 'disabled'
  export const icon = 'icon'
  export const standard = 'standard'
}

type TokenVariant =
  | typeof TokenVariantNS.disabled
  | typeof TokenVariantNS.icon
  | typeof TokenVariantNS.standard

interface TokenProps extends Props {
  disabled?: boolean
  variant?: TokenVariant
}

const cx = bind(styles)

const Token = React.forwardRef<HTMLLabelElement, DivAttributes & TokenProps>(
  (
    {
      children,
      className,
      disabled = false,
      variant = TokenVariantNS.standard,
      ...props
    },
    ref
  ) => (
    <div
      className={cx(
        'core-token',
        {
          [`core-token--${TokenVariantNS.disabled}`]: disabled,
          [`core-token--${variant}`]: variant,
        },
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
)

const Icon = React.forwardRef<HTMLSpanElement, SpanAttributes & IconProps>(
  ({ className, icon, ...props }, ref) => (
    <IconBase
      ref={ref}
      icon={icon}
      className={cx('core-token__icon', className)}
      {...props}
    />
  )
)

const Label = React.forwardRef<HTMLSpanElement, SpanAttributes & Props>(
  ({ children, className, ...props }, ref) => (
    <span ref={ref} className={cx('core-token__label', className)} {...props}>
      {children}
    </span>
  )
)

Token.displayName = 'Token'

Icon.displayName = 'Token.Icon'

Label.displayName = 'Token.Label'

export default addSubcomponents(
  {
    Icon,
    Label,
  },
  Token
)
